import { useUserStore } from "@app/state/store";
import Icon from "@lib/common/components/Icon/Icon";
import { Group, Text, Tooltip } from "@mantine/core";
import { isNil } from "lodash-es";

export default function OrganizationLabel() {
  const user = useUserStore();

  if (isNil(user)) {
    return null;
  }

  return (
    <Tooltip label="Your organization">
      <Group gap={6} px={8} wrap="nowrap">
        <Icon name="buildings" variant="solid" />
        <Text size="sm" fw={500}>
          {user.current_organization.name}
        </Text>
      </Group>
    </Tooltip>
  );
}
